import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CurrentAccountBilletModel } from '../model/currentAccountBilletModel';

@Component({
   selector: 'mappingCurrentAccountBillet-dialog',
   templateUrl: './mappingCurrentAccountBillet-dialog.component.html',
   styleUrls: [],
})
export class MappingCurrentAccountBilletDialog {
   public contractSelected: string;
   public mappingModel: CurrentAccountBilletModel[];

   constructor(
      public dialogRef: MatDialogRef<MappingCurrentAccountBilletDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,
   ) {
      this.contractSelected = data?.contractSelected;
      this.mappingModel = data?.mapping;
   }
}
